export default {
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS',
};
